export default class LoadingIndicatorExtension {
    constructor(defaultLoadingIndicatorSelector) {
        this.defaultLoadingIndicatorSelector = defaultLoadingIndicatorSelector;
        this.overlay = document.createElement('div');
        this.overlay.innerHTML = '<div class="spinner-border text-secondary" role="status"><span class="visually-hidden">Loading...</span></div>';
        this.overlay.style.cssText = `
            background-color: rgba(0,0,0, 0.4);
            position: absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            content: '';
            transition: all 0.2s;
            text-align: center;
        `;

        this.originalPosition;

    }

    initialize(naja) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.defaultLoadingIndicator = document.querySelector(this.defaultLoadingIndicatorSelector);
            });
        } else {
            this.defaultLoadingIndicator = document.querySelector(this.defaultLoadingIndicatorSelector);
        }

        naja.uiHandler.addEventListener('interaction', this.locateLoadingIndicator.bind(this));
        naja.addEventListener('start', this.showLoader.bind(this));
        naja.addEventListener('complete', this.hideLoader.bind(this));
    }

    locateLoadingIndicator(event) {
        let loadingIndicator = event.detail.element.closest('[data-loading-indicator]');
        event.detail.options.loadingIndicator = loadingIndicator || this.defaultLoadingIndicator;
    }

    showLoader(event) {
        let loadingIndicator = event.detail.options.loadingIndicator;
        this.originalPosition = loadingIndicator.style.position;
        loadingIndicator.style.position = 'relative';
        loadingIndicator?.append(this.overlay);
    }

    hideLoader(event) {
        let loadingIndicator = event.detail.options.loadingIndicator;
        loadingIndicator.style.position = this.originalPosition;
        this.overlay.remove();
    }

}